__turbopack_context__.v({
  "clearBtn": "HeaderSearchBox-module__H0fXAW__clearBtn",
  "desktop": "HeaderSearchBox-module__H0fXAW__desktop",
  "dropdown": "HeaderSearchBox-module__H0fXAW__dropdown",
  "emptyText": "HeaderSearchBox-module__H0fXAW__emptyText",
  "input": "HeaderSearchBox-module__H0fXAW__input",
  "mobile": "HeaderSearchBox-module__H0fXAW__mobile",
  "productImage": "HeaderSearchBox-module__H0fXAW__productImage",
  "productInfo": "HeaderSearchBox-module__H0fXAW__productInfo",
  "productItem": "HeaderSearchBox-module__H0fXAW__productItem",
  "productName": "HeaderSearchBox-module__H0fXAW__productName",
  "productPrice": "HeaderSearchBox-module__H0fXAW__productPrice",
  "searchBox": "HeaderSearchBox-module__H0fXAW__searchBox",
  "searchBtn": "HeaderSearchBox-module__H0fXAW__searchBtn",
  "searchWrap": "HeaderSearchBox-module__H0fXAW__searchWrap",
  "section": "HeaderSearchBox-module__H0fXAW__section",
  "sectionTitle": "HeaderSearchBox-module__H0fXAW__sectionTitle",
  "simpleItem": "HeaderSearchBox-module__H0fXAW__simpleItem",
  "viewAll": "HeaderSearchBox-module__H0fXAW__viewAll",
});
